document.addEventListener('DOMContentLoaded', function() {

  const IS_PDP = document.body.classList.contains('template-product');
  const IS_PLP = !IS_PDP;

  function initFinalSale(wrapper) {
    if (wrapper.__finalSaleInit) return;
    wrapper.__finalSaleInit = true;

    const PRODUCT_ID = wrapper.dataset.productId;
    const PROP_NAME = wrapper.dataset.propName;
    const PROP_VALUE = wrapper.dataset.propValue;
    const SELECTED_VARIANT_ID = wrapper.dataset.selectedVariantId;
    const FINAL_SALE_MAP = JSON.parse(wrapper.dataset.finalSaleMap);

    const label = wrapper.querySelector('[data-final-sale-label]');
    let currentVariantId = null;
    let propertyInputs = new Map();

    const forms = document.querySelectorAll('form[action*="/cart/add"]');

    function isFinalSaleVariant(variantId) {
      return FINAL_SALE_MAP[String(variantId)] === true;
    }

    function updateLabel(isFinalSale) {
      if (!label) return;
      if (isFinalSale) {
        label.removeAttribute('hidden');
        label.setAttribute('aria-hidden', 'false');
      } else {
        label.setAttribute('hidden', '');
        label.setAttribute('aria-hidden', 'true');
      }
    }

    function getPropertyInput(form) {
      if (propertyInputs.has(form)) return propertyInputs.get(form);
      let input = form.querySelector(`input[name="${PROP_NAME}"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = PROP_NAME;
        form.appendChild(input);
      }
      propertyInputs.set(form, input);
      return input;
    }

    function updateForms(isFinalSale) {
      forms.forEach(form => {
        if (isFinalSale) {
          const input = getPropertyInput(form);
          input.value = PROP_VALUE;
        } else {
          const input = form.querySelector(`input[name="${PROP_NAME}"]`);
          if (input) {
            input.remove();
            propertyInputs.delete(form);
          }
        }
      });
    }

    function updateFinalSaleState(variantId) {
      if (!variantId) variantId = SELECTED_VARIANT_ID;
      variantId = String(variantId);
      if (variantId === currentVariantId) return;
      currentVariantId = variantId;

      const isFinalSale = isFinalSaleVariant(variantId);
      updateLabel(isFinalSale);
      updateForms(isFinalSale);
    }

    function handleVariantChange(event) {
      let variantId = event?.detail;
      updateFinalSaleState(variantId);
    }

    document.addEventListener('product:variant:change', handleVariantChange);
    document.addEventListener('change', e => {
      if (e.target && e.target.matches('form[action*="/cart/add"] [name="id"]')) {
        updateFinalSaleState(e.target.value);
      }
    });

    document.addEventListener('submit', e => {
      if (e.target && e.target.matches('form[action*="/cart/add"]')) {
        updateFinalSaleState(currentVariantId);
      }
    }, true);

    document.addEventListener('click', e => {
      const expressButton = e.target.closest(
        '.shopify-payment-button__button, .shopify-payment-button button, button[name="checkout"], a[href*="/checkout"]'
      );
      if (expressButton) {
        updateFinalSaleState(currentVariantId);
      }
    }, true);

    // Initial update
    updateFinalSaleState();

    // quickview variant change
    document.addEventListener('change', function (e) {
      const form = e.target.closest('.quick-view form[action*="/cart/add"]#product_form_' + PRODUCT_ID);
      if (!form) return;
      if (e.target.name && e.target.name.startsWith('option')) {
        requestAnimationFrame(() => {
          const variantInput = form.querySelector('[name="id"]');
          if (variantInput && variantInput.value) {
            updateFinalSaleState(variantInput.value);
          }
        });
      }
    }, true);

  }

  document.querySelectorAll('[data-final-sale-wrapper]').forEach(initFinalSale);

  // quickview
  function initAllFinalSaleWrappers(root = document) {
    root?.querySelectorAll('[data-final-sale-wrapper]')?.forEach(initFinalSale);
  }

  function observeQuickViewOpen() {
    const quickViewObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if ( mutation.type === 'attributes' && mutation.attributeName === 'class' ) {
          const modal = mutation.target;
          if ( modal.classList.contains('js-quick-view') && modal.classList.contains('is-active') ) {
            initAllFinalSaleWrappers(modal);
          }
        }
      });
    });
    quickViewObserver.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  observeQuickViewOpen();

  // Handle Nosto dynamic card variant-id attribute
  function handleNostoVariantId(nostoCard) {
    const variantId = nostoCard.getAttribute('variant-id');
    if (!variantId) return;

    function processCard() {
      const productCard = nostoCard.querySelector('.js-product-card');
      if (!productCard) return false;

      if (productCard.dataset.variantIdProcessed === variantId) return true;

      const imageWrapper = productCard.querySelector(`[data-variant="${variantId}"]`);
      if (!imageWrapper) return false;

      const targetColor = imageWrapper.getAttribute('data-image');
      if (!targetColor) return false;

      const imageWrappers = productCard.querySelectorAll('.js-product-card-images-wrapper');
      imageWrappers.forEach(wrapper => wrapper.classList.remove('is-active'));

      imageWrapper.classList.add('is-active');

      const swatchButtons = productCard.querySelectorAll('.js-product-card-swatch');
      swatchButtons.forEach(btn => {
        const swatchValue = btn.getAttribute('data-swatch');
        if (swatchValue === targetColor) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });

      // Update final sale state for this variant
      const finalSaleWrapper = productCard.querySelector('[data-final-sale-wrapper]');
      if (finalSaleWrapper) {
        if (!finalSaleWrapper.__finalSaleInit) {
          initFinalSale(finalSaleWrapper);
        }
        const updateEvent = new CustomEvent('product:variant:change', { detail: variantId });
        document.dispatchEvent(updateEvent);
      }

      productCard.dataset.variantIdProcessed = variantId;
      return true;
    }

    if (processCard()) return;

    const observer = new MutationObserver((mutations, obs) => {
      if (processCard()) {
        obs.disconnect();
      }
    });

    observer.observe(nostoCard, { childList: true, subtree: true });
  }

  if (IS_PLP) {
    // Function to process all Nosto cards with variant-id
    function processAllNostoCards() {
      document.querySelectorAll('nosto-dynamic-card[variant-id]').forEach(card => {
        if (!card.dataset.variantProcessed) {
          card.dataset.variantProcessed = 'true';
          handleNostoVariantId(card);
        }
      });
    }

    // Initial observer to detect when Nosto container appears
    const nostoObserver = new MutationObserver((mutations, observer) => {
      const nostoContainer = document.querySelector('nosto-dynamic-card');
      if (!nostoContainer) return;
      initAllFinalSaleWrappers(nostoContainer);
      processAllNostoCards();

      const contentObserver = new MutationObserver((contentMutations) => {
        contentMutations.forEach((m) => {
          m.addedNodes.forEach((node) => {
            if (node.nodeType !== 1) return;

            if (node.matches?.('nosto-dynamic-card[variant-id]')) {
              if (!node.dataset.variantProcessed) {
                node.dataset.variantProcessed = 'true';
                handleNostoVariantId(node);
              }
            }

            if (node.matches?.('[data-final-sale-wrapper]')) {
              initFinalSale(node);
            }
            node.querySelectorAll?.('[data-final-sale-wrapper]')?.forEach(initFinalSale);

            node.querySelectorAll?.('nosto-dynamic-card[variant-id]')?.forEach(card => {
              if (!card.dataset.variantProcessed) {
                card.dataset.variantProcessed = 'true';
                handleNostoVariantId(card);
              }
            });
          });
        });
      });
      contentObserver.observe(nostoContainer, { childList: true, subtree: true });
      observer.disconnect();
    });
    nostoObserver.observe(document.body, { childList: true, subtree: true });

    // Handle "Load More" button clicks
    document.addEventListener('click', function(e) {
      const loadMoreBtn = e.target.closest('.ns-load-more');
      if (!loadMoreBtn) return;

      const loadMoreObserver = new MutationObserver((mutations) => {
        const newCards = document.querySelectorAll('nosto-dynamic-card[variant-id]:not([data-variant-processed])');
        if (newCards.length > 0) {
          processAllNostoCards();
          initAllFinalSaleWrappers(document);
          loadMoreObserver.disconnect();
        }
      });

      const nostoContainer = document.querySelector('nosto-dynamic-card')?.parentElement || document.body;
      loadMoreObserver.observe(nostoContainer, { childList: true, subtree: true });

      setTimeout(() => loadMoreObserver.disconnect(), 5000);
    });

    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('nosto-dynamic-card[variant-id]').forEach(card => {
        if (!card.dataset.variantProcessed) {
          card.dataset.variantProcessed = 'true';
          handleNostoVariantId(card);
        }
      });
    });
  }

  // product card variant swatch image load
  document.addEventListener("click", (e) => {
    const swatch = e.target.closest(".js-product-card-swatch");
    if (!swatch) return;

    const productCard = swatch.closest("nosto-dynamic-card, .product-card");
    if (!productCard) return;

    requestAnimationFrame(() => {
      window?.themeCore?.LazyLoadImages?.init();
    });
  });

  document.addEventListener("click", function (event) {
    const quickShopBtn = event.target.closest(".product-card__quick-shop-button");
    if (!quickShopBtn) return;

    event.preventDefault();

    const nostoCard = quickShopBtn.closest("nosto-dynamic-card");
    if (!nostoCard) return;

    const productHandle = quickShopBtn.getAttribute("data-product-handle");
    const activeSwatch = nostoCard.querySelector(".js-product-card-swatch.is-active");
    const variantId = activeSwatch?.getAttribute("data-variant-id");

    if (window.themeCore?.EventBus && productHandle && variantId) {
      window.themeCore.EventBus.emit("product-card:quick-view:clicked", {
        productHandle: productHandle,
        variant: variantId
      });
    }
  }, true);

  document.addEventListener('click', handleSwatchScroll);
});

function handleSwatchScroll(event) {
    const forwardBtn = event.target.closest('.forward');
    const backwardBtn = event.target.closest('.backward');

    if (!forwardBtn && !backwardBtn) return;

    const wrapper = event.target.closest('.product-card__swatches-wrapper');
    if (!wrapper) return;

    const container = wrapper.querySelector('.product-card__swatches');
    if (!container) return;

    if (forwardBtn) {
      container.scrollLeft -= 100;
    }

    if (backwardBtn) {
      container.scrollLeft += 100;
    }
}

(function () {
  var sectionEl = document.querySelector(".nosto-tabs-section");
  if (!sectionEl) return;

  function openTab(tabId) {
    sectionEl.querySelectorAll('.tab').forEach(function (btn) {
      btn.classList.remove('active');
      btn.setAttribute('aria-selected', 'false');
    });
    sectionEl.querySelectorAll('.tab-content').forEach(function (panel) {
      panel.classList.remove('active');
    });

    var targetBtn   = sectionEl.querySelector('[data-tab="' + tabId + '"]');
    var targetPanel = document.getElementById('panel-' + tabId);

    if (targetBtn)   { targetBtn.classList.add('active');   targetBtn.setAttribute('aria-selected', 'true'); }
    if (targetPanel) { targetPanel.classList.add('active'); }
  }

  sectionEl.querySelectorAll('.tab').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openTab(btn.getAttribute('data-tab'));
    });
  });

  function checkNostoEmpty() {
    var panels      = sectionEl.querySelectorAll('.tab-content');
    var visibleTabs = [];

    panels.forEach(function (panel) {
      var placementId = panel.getAttribute('data-placement');
      var nostoEl     = document.getElementById(placementId);
      var isEmpty     = !nostoEl || nostoEl.innerHTML.trim() === '';

      var tabId  = panel.id.replace('panel-', '');
      var tabBtn = sectionEl.querySelector('[data-tab="' + tabId + '"]');

      if (isEmpty) {
        if (tabBtn) tabBtn.classList.add('nosto-hidden');
        panel.classList.remove('active');
      } else {
        if (tabBtn) tabBtn.classList.remove('nosto-hidden');
        visibleTabs.push(tabId);
      }
    });

    if (visibleTabs.length === 0) {
      sectionEl.classList.add('all-hidden');
    } else {
      sectionEl.classList.remove('all-hidden');
      openTab(visibleTabs[0]);
    }
  }

  checkNostoEmpty();

  var observer = new MutationObserver(function () {
    checkNostoEmpty();
  });

  sectionEl.querySelectorAll('.tab-content').forEach(function (panel) {
    var placementId = panel.getAttribute('data-placement');
    var nostoEl     = document.getElementById(placementId);
    if (nostoEl) {
      observer.observe(nostoEl, { childList: true, subtree: true });
    }
  });
})();  
